<template>
  <form class="mb-8 flex flex-col gap-[20px] font-Spectral">
    <div v-for="(questionAnswer, index) in form.step2.reservationQuestionAnswers" :key="questionAnswer.id">
      <!-- 自由テキスト -->
      <WrappedTextarea
        v-if="questionAnswer.questionType === 'FreeText'"
        :id="questionAnswer.id"
        v-model="questionAnswer.answer"
        lang="en"
        :aria-label="`answer-${index}`"
        :error="getErrorMessage(`step2.reservationQuestionAnswers[${index}]`)"
        :label="questionAnswer.content"
        :placeholder="questionAnswer.placeHolder"
        :required="questionAnswer.isRequired"
      />
      <!-- 単一選択（ラジオボタン） -->
      <WrappedRadioQuestion
        v-else-if="questionAnswer.questionType === 'Radio'"
        :answer-options="questionAnswer.answerOptions"
        :error="getErrorMessage(`step2.reservationQuestionAnswers[${index}]`)"
        :label="questionAnswer.content"
        :model-value="parsedAnswers[index]"
        :on-update-model-value="
          (value: string) => {
            questionAnswer.answer = JSON.stringify([value]);
          }
        "
        :required="questionAnswer.isRequired"
      />
      <!-- 複数選択（チェックボックス） -->
      <WrappedCheckboxQuestion
        v-else-if="questionAnswer.questionType === 'Checkbox'"
        :answer-options="questionAnswer.answerOptions"
        :error="getErrorMessage(`step2.reservationQuestionAnswers[${index}]`)"
        :label="questionAnswer.content"
        :model-value="parsedAnswers[index]"
        :on-update-model-value="
          (value: string[]) => {
            questionAnswer.answer = JSON.stringify(value);
          }
        "
        :question-id="questionAnswer.id"
        :required="questionAnswer.isRequired"
      />
    </div>
  </form>
</template>

<script setup lang="ts">
import { WrappedCheckboxQuestion, WrappedRadioQuestion, WrappedTextarea } from '@/wabunka-src/common/components';
import { useGlobalWabunkaReservationForm } from '@/wabunka-src/common/features/Reservation/composables/forms/useGlobalWabunkaReservationForm';

interface Props {
  getErrorMessage: (s: string) => string;
}

defineProps<Props>();
const { form } = useGlobalWabunkaReservationForm();

/** 各質問のanswer(JSON配列文字列)をパースした値 */
const parsedAnswers = computed(() =>
  form.value.step2.reservationQuestionAnswers.map((qa) => {
    if (qa.questionType === 'Radio') {
      if (!qa.answer) return '';
      try {
        const arr = JSON.parse(qa.answer);
        return Array.isArray(arr) && arr.length > 0 ? arr[0] : '';
      } catch {
        return '';
      }
    }
    if (qa.questionType === 'Checkbox') {
      if (!qa.answer) return [];
      try {
        const parsed = JSON.parse(qa.answer);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return qa.answer;
  }),
);
</script>
